<template>
  <v-tooltip v-if="!permission" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        class="mr-2"
        dark
        :color="actionColor"
        @click="onClick(data)"
        v-bind="attrs"
        v-on="on"
      >
        {{ iconName }}
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
const props = {
  iconName: {
    default: "mdi-person",
    type: String,
  },
  text: {
    default: "No disponible",
    type: String,
  },
  permission: {
    default: true,
    type: Boolean,
  },
  actionColor: {
    default: "green",
    type: String,
  },
  data: {
    type: undefined,
  },
  onClick: Function,
};

export default {
  data: () => ({
    valueOk: false,
  }),
  methods: {
  },
  props: props,
};
</script>

<style scoped></style>
